module.exports = __webpack_public_path__ + "5b0f44524341b18e9a106419c6f9d62b.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/support-business/Tri_Tue.svg
// module id = ./assets/images/support-business/Tri_Tue.svg
// module chunks = 0